import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useHistory } from 'react-router-dom'

export default function AccountNav(props) {
  const history = useHistory()
  const rootPath = window.location.pathname
  // TODO replace logout prop func with store
  const {
    menuAnchorEl,
    handleMenuOpen,
    handleMenuClose,
    logout,
    api,
    menuEl,
    styles
  } = props

  // eslint-disable-next-line no-unused-vars
  const [patientLink, setPatientLink] = useState(null)

  useEffect(() => {
    const fetchPatientLink = async () => {
      const path =
        process.env.REACT_APP_NODE_API_ROOT_URL + `/clinicians/patient-link`
      const json = await api.GET(path)
      setPatientLink(json.url)
    }

    fetchPatientLink()
    //  no need to update once fetched - this is a static link based on clinician display id
  }, [])

  const handleMenuLinkClick = path => () => {
    history.push(path)
    handleMenuClose()
  }

  return (
    <>
      <a
        id="account-nav-menu"
        className={styles.link}
        onClick={handleMenuOpen}
        tabIndex="0"
        role="button"
        onKeyDown={e => {
          const key = e.which
          if (key === 13 || key === 32) handleMenuOpen(e)
        }}
        data-click-text="Settings Menu"
      >
        {menuEl
          ? menuEl
          : <img
              alt="Clinician account menu"
              style={{ height: '40px' }}
              src="https://res.cloudinary.com/hellojoy/image/upload/v1555167552/avatar_viwufc.png"
            />}
      </a>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl) && menuAnchorEl.id === 'account-nav-menu'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <MenuItem
          tabIndex={1}
          selected={rootPath.indexOf('settings/account') > -1}
          onClick={handleMenuLinkClick(`/settings/account`)}
        >
          Clinician Account
        </MenuItem>
        {!isMobile && (
          <MenuItem
            selected={rootPath.indexOf('settings/assessments') > -1}
            onClick={handleMenuLinkClick(`/settings/assessments`)}
          >
            Assessments
          </MenuItem>
        )}
        <MenuItem
          selected={rootPath.indexOf('settings/notifications') > -1}
          onClick={handleMenuLinkClick(`/settings/notificaitons`)}
        >
          Notifications
        </MenuItem>
        <MenuItem onClick={logout}>Log out</MenuItem>
      </Menu>
    </>
  )
}
